import type { ReactNode } from "react";
import { BottomNav } from "./BottomNav";
import type { NavId } from "../lib/routes";

interface AppShellProps {
  active: NavId;
  onNavigate: (path: string) => void;
  fab?: ReactNode;
  offlineBanner?: ReactNode;
  children: ReactNode;
}

export function AppShell({ active, onNavigate, fab, offlineBanner, children }: AppShellProps) {
  return (
    <div className="shell">
      <a className="skip-link" href="#main-content">
        رفتن به محتوای اصلی
      </a>
      <div className="shell__body">
        <main id="main-content" className="shell__page">
          {offlineBanner}
          {children}
        </main>
        {fab}
        <BottomNav active={active} onNavigate={onNavigate} />
      </div>
    </div>
  );
}
